export const VARIANT_LIST = ['base', 'outline', 'dashed', 'text'];
export const THEME_LIST = ['default', 'primary', 'danger'];
export const SIZE_LIST = ['large', 'medium', 'small'];
export const SHAPE_LIST = ['default', 'round', 'circle'];
